export default {
  async request(url, options) {
    const defaultHeaders = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    const commonOptions = {
      headers: new Headers(defaultHeaders),
    };
    const fetchOptions = {
      ...options,
      ...commonOptions,
    };

    const response = await fetch(url, fetchOptions);

    if (response.ok) {
      return response.json();
    }
    throw response;
  },
}
;



// WEBPACK FOOTER //
// ./src/js/lib/http.js